<template>
  <v-container>
    <v-alert
          v-model="alertErro"
          dismissible
          close-icon="mdi-delete"
          colored-border
          border="left"
          color="red"
          elevation="2"
          type="error"
        >
      <p v-html="mensagemErro"></p>
    </v-alert>
    <v-row justify="center">
      <v-col cols="3" class="text-center">
        <v-form @submit.prevent="calcular">
          <DatePicker
            ref="dataAtualizacaoDatePicker"
            nome="Nova Data de Atualização"
            regras="data|required"
            tipo="dataAtualizacao"
          />
          <v-btn
            color="primary"
            class="mt-4"
            type="submit"
            :loading="loading"
            :disabled="loading"
          >
            Calcular
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <Resultados :nome="tituloCalculo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DatePicker from "@/components/DatePicker.vue";
import Resultados from "@/components/Resultados.vue";
import axios from 'axios';

export default {
  components: {
    DatePicker,
    Resultados
  },
  data() {
    return {
      loading: false,
      alertErro: false,
      mensagemErro: '',
      tituloCalculo: 'Débitos em Apuração'
    };
  },
  computed: {
    ...mapState(['calculos'])
  },
  created() {
    this.fetchCalculos();
  },
  methods: {
    ...mapActions(['setCalculos', 'clearCalculos']),
    async fetchCalculos() {
      const hash = this.$route.params.hash;
      try {
        const response = await axios.get(`/calculo/${hash}`);
        console.log('response.data', response.data);
        if (response.data.sucesso) {
          this.tituloCalculo = response.data.tipo === 'encargosMoratorios' 
            ? 'Encargos Moratórios' 
            : 'Débitos em Apuração';
          const formattedCalculos = response.data.calculo.map(calculo => ({
            dataValorOriginal: calculo[0],
            valorOriginal: calculo[1],
            descricao: calculo[2],
            dataJuros: calculo[3],
            dataAtualizacao: calculo[4],
            correcaoMonetaria: calculo[5],
            multa: calculo[6],
            jurosPre2020: calculo[7],
            jurosPos2020: calculo[8],
            valorCorrigido: calculo[9]
          }));
          this.setCalculos(formattedCalculos);
        } else {
          console.error('Falha ao recuperar cálculos');
        }
      } catch (error) {
        console.error('Erro ao recuperar cálculos:', error);
      }
    },
    async calcular() {
      this.loading = true;
      this.alertErro = false;
      const hash = this.$route.params.hash;
      const novaDataAtualizacao = this.$store.state.dataAtualizacao;
      
      if (!novaDataAtualizacao) {
        console.error('Data de atualização não selecionada');
        this.loading = false;
        return;
      }

      try {
        const response = await axios.get(`/calculo/${hash}/recalcular`, {
          params: {
            dataAtualizacao: novaDataAtualizacao
          }
        });

        if (response.data.sucesso) {
          this.setCalculos(response.data.calculo);
        } else {
          this.mensagemErro = response.data.erro.mensagem;
          this.alertErro = true;
          console.error('Falha ao recalcular:', response.data.mensagem);
        }
      } catch (error) {
        if (error.response && error.response.data && !error.response.data.sucesso) {
          this.mensagemErro = error.response.data.erro.mensagem;
          this.alertErro = true;
        }
        console.error('Erro ao recalcular:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
